import { Component, OnInit } from '@angular/core';
import { Configuration, Encrypted } from 'src/app/Constants/configuration';
import { StyleCocheSeguro } from 'src/app/modelos/styleCocheseguro.model';
import { Cancelacion } from 'src/app/modelos/cancelacion.model';
import { Endoso } from 'src/app/modelos/endoso.model';
import { Adjunto } from 'src/app/modelos/adjunto.model';
import { Cias } from 'src/app/modelos/cias.model';
import { Prospecto } from 'src/app/modelos/prospecto.model';
import { Compartir } from 'src/app/modelos/compartir.model';
import { EmisionService } from 'src/app/services/emision.service';
import { NotificacionService } from 'src/app/services/notificacion.service';
import { LogConsumoFunciones } from 'src/app/utilities/logConsumo';
import { RequestServices } from 'src/app/services/request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage.service';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
declare var gtag;

@Component({
  selector: 'app-pago-en-linea-gnp',
  templateUrl: './pago-en-linea-gnp.component.html'
})
export class PagoEnLineaGnpRenovacionComponent implements OnInit {
  private configuration: Configuration = new Configuration();
  public styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
  public ec: Encrypted = new Encrypted();
  cancel: Cancelacion = new Cancelacion();
  endoso: Endoso = new Endoso();
  adjunto: Adjunto = new Adjunto();
  cias: Cias = new Cias();
  prospecto: Prospecto = new Prospecto();
  compartir: Compartir = new Compartir();
  public validando: Number = 1;
  public mensajeResponse: string = '';
  public subscribe;
  public parameters: Array<any> = new Array<any>();
  public emisionService: EmisionService;
  public notificacionService: NotificacionService = new NotificacionService(this.requestService);
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
  private jsonSave = {
    reciboId: '',
    base: {
      emisionId: 0,
      ciaId: 0,
      ciaString: '',
      clienteId: 0,
      noPoliza: '',
      worksiteId: 0
    },
    total: '',
    liquidacion: '',
    documento: '',
    formaCobro: 0,
    comentario: '',
    fecPago: '',
    pagoId: 0, // pagoId de quattroAutos
    refProg: '', // referencia para pago domiciliado, TipOP = 1, 2
    reciboIdComplemento: ''
  }
  private cocheSeguro: CocheSeguro = new CocheSeguro();
  private modeloCorreo: number;
  private isError: boolean = false;
  constructor(private requestService: RequestServices, private route: ActivatedRoute, private router: Router, private http: HttpClient, private dialog: MatDialog, private storageService: StorageService) {
    this.emisionService = new EmisionService(http, this.requestService);
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }
  }

  ngOnInit(): void {
    this.cocheSeguro.url = this.router.url;
    if (this.storageService.ifExist("cocheSeguro")) {
      this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      switch (this.cocheSeguro.paquete) {
        case 0: // AMPLIA
          this.modeloCorreo = 23;
          break;
        case 1: // LIMITADA
          this.modeloCorreo = 24;
          break;
        case 2: // BÁSICA
          this.modeloCorreo = 24;
          break;
      }
    }
    if (this.cocheSeguro?.prospecto) {
      this.prospecto = this.cocheSeguro.prospecto;
    }
    this.subscribe = this.route.queryParams.subscribe(params => {
      if (params) {
        // params = JSON.parse(JSON.stringify(params));
        // params.Res = "1";
        // params.Pol = "00000403606106";
        // params.Seg = "00003";
        // params.nCon = "30000";
        // params.Idt = "CNNNPRUEBA0001";
        this.parameters = [];
        this.parameters.push(params);

        if (this.parameters[0].Res) {
          if (!isNaN(Number(this.parameters[0].Res))) {
            this.pagoExitoso(Number(this.parameters[0].Res));
            switch (Number(this.parameters[0].Res)) {
              case 1: //Transaccion exitosa
                if (this.cocheSeguro.paquete) {
                  this.cocheSeguro.opcion = this.cocheSeguro.paquete;
                }
                if (this.parameters[0].pol) {
                  this.cocheSeguro.polizaIdEnc = this.parameters[0].pol;
                }
                this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));
                this.logConsumoFun.logConsumo(77); // PASO INSERTADO COMO "COMPRA EXITOSA"
                gtag({ 'event': 'formStep5Submit' });
                setTimeout(() => {
                  if (this.storageService.ifExist("logConsumoId")) {
                    this.storageService.removeItem("logConsumoId");
                  }
                }, 1000);

                if (this.parameters[0].Pol) {
                  if (!String(this.parameters[0].Pol).includes("error") && String(this.parameters[0].Pol).length < 15) {
                    this.actualizaNoPol();
                  } else { //Caso donde el pago se efectúa pero la emision genera error
                    this.isError = true;
                    this.notificacionService.notificacionCRM({
                      url: this.cocheSeguro.url ? this.cocheSeguro.url : '',
                      aseguradoraID: Number(this.parameters[0].cid),
                      emisionID: this.parameters[0].eid ? this.parameters[0].eid : '',
                      msgError: this.parameters[0].Pol,
                      clienteID: this.parameters[0].clid ? Number(this.parameters[0].clid) : 0
                    });
                  }
                }
                this.setJsonData();
                this.creacionPolINBROKER();
                break;
              case 2: //Transacción fallida
                this.logConsumoFun.logConsumo(66);// PASO INSERTADO COMO "COMPRA INCONCLUSA"
                setTimeout(() => {
                  if (this.storageService.ifExist("logConsumoId")) {
                    this.storageService.removeItem("logConsumoId");
                  }
                }, 1000);
                this.cancelacion();
                break;
              default:
                this.cancelacion();
                break;
            }
          } else {
            this.pagoExitoso(0);  
            this.cancelacion();
          }
        } else {
          this.pagoExitoso(0);
          this.cancelacion();
        }
      } else {
        this.cancelacion();
      }
    });
  }

  setJsonData() {
    if (this.parameters[0].nCon) {
      this.jsonSave.liquidacion = this.parameters[0].nCon;
    }
    if (this.parameters[0].rid) {
      this.jsonSave.reciboId = this.parameters[0].rid;
    }
    if (this.parameters[0].clid) {
      this.jsonSave.base.clienteId = Number(this.parameters[0].clid);
    }
    if (this.parameters[0].wid) {
      this.jsonSave.base.worksiteId = Number(this.parameters[0].wid);
    }
    if (this.parameters[0].cia) {
      this.jsonSave.base.ciaString = this.parameters[0].cia;
    }
    if (this.parameters[0].eid) {
      this.jsonSave.base.emisionId = Number(this.parameters[0].eid);
    }
    if (this.parameters[0].cid) {
      this.jsonSave.base.ciaId = Number(this.parameters[0].cid);
    }
    if (this.parameters[0].tot) {
      this.jsonSave.total = this.parameters[0].tot;
    }
    if (this.parameters[0].pid) {
      this.jsonSave.pagoId = Number(this.parameters[0].pid);
    }
    if (this.parameters[0].pol) {
      this.jsonSave.base.noPoliza = this.parameters[0].pol;
    }
    if (this.parameters[0].Seg) {
      this.jsonSave.refProg = this.parameters[0].Seg;
    }
    if (this.parameters[0].ridCom) {
      this.jsonSave.reciboIdComplemento = this.parameters[0].ridCom;
    }

    this.jsonSave.comentario = this.getComentario();
    this.jsonSave.fecPago = this.getFecha();

    this.pagoQuattro();
  }

  private getComentario() {
    let comentario = "";

    if (this.parameters[0].nCon) {
      comentario += "Número de confirmación: " + this.parameters[0].nCon;
    }

    if (this.parameters[0].Seg) {
      comentario += "\nNúmero de seguimiento: " + this.parameters[0].Seg;
    }

    if (this.parameters[0].Idt) {
      comentario += "\nNúmero de cotización: " + this.parameters[0].Idt;
    }
    return comentario.trim();
  }

  getFecha() {
    let fecStr = '';
    try {
      const now = new Date();
      fecStr += now.getFullYear().toString();
      fecStr += '-' + (((now.getMonth() + 1) < 10) ? ('0' + (now.getMonth() + 1)) : now.getMonth() + 1);
      fecStr += '-' + ((now.getDate() < 10) ? ('0' + now.getDate()) : now.getDate());
      fecStr += ' ' + ((now.getHours() < 10) ? ('0' + now.getHours()) : now.getHours());
      fecStr += ':' + ((now.getMinutes() < 10) ? ('0' + now.getMinutes()) : now.getMinutes());
      fecStr += ':' + ((now.getSeconds() < 10) ? ('0' + now.getSeconds()) : now.getSeconds());
    } catch (error) {
      fecStr = '';
    }
    return fecStr;
  }

  pagoQuattro() {
    /**Pago de recibo póliza principal */
    this.emisionService.generaPagoPrimerRecibo({
      reciboId: this.jsonSave.reciboId,
      base: {
        emisionId: this.jsonSave.base.emisionId,
        ciaId: this.jsonSave.base.ciaId,
        ciaString: this.jsonSave.base.ciaString,
        clienteId: this.jsonSave.base.clienteId,
        noPoliza: this.jsonSave.base.noPoliza,
        worksiteId: this.jsonSave.base.worksiteId
      },
      total: this.jsonSave.total,
      liquidacion: this.jsonSave.liquidacion,
      documento: this.jsonSave.documento,
      formaCobro: 0,
      comentario: this.jsonSave.comentario,
      fecPago: this.jsonSave.fecPago
    });
    /**Pago de recibo póliza complemento */
    this.emisionService.generaPagoPrimerRecibo({
      reciboId: this.jsonSave.reciboIdComplemento,
      base: {
        emisionId: this.jsonSave.base.emisionId,
        ciaId: this.jsonSave.base.ciaId,
        ciaString: this.jsonSave.base.ciaString,
        clienteId: this.jsonSave.base.clienteId,
        noPoliza: this.jsonSave.base.noPoliza,
        worksiteId: this.jsonSave.base.worksiteId
      },
      total: '0',
      liquidacion: this.jsonSave.liquidacion,
      documento: this.jsonSave.documento,
      formaCobro: 0,
      comentario: this.jsonSave.comentario,
      fecPago: this.jsonSave.fecPago
    });
    if (this.isError) {
      this.goMiCuenta();
    } else {
      this.realizaImpresion();
    }
  }

  private realizaImpresion() {
    // this.goMiCuenta();
    this.emisionService.generaImpresionAdjuntoAsync(
      {
        basic: {
          emisionId: Number(this.parameters[0].eid),
          ciaId: Number(this.parameters[0].cid),
          ciaString: this.parameters[0].cia,
          clienteId: Number(this.parameters[0].clid),
          noPoliza: String(this.parameters[0].Pol),
          worksiteId: Number(this.parameters[0].wid)
        },
        cotizacionId: 0,
        conductor: '',
        polizaId: this.parameters[0].pol
      }).subscribe(
        result => {
          if (result.error) {
            console.error(result.error);
            this.validando = 0;
            this.goMiCuenta();
          } else {
            this.validando = 0;
            this.compartirMiPoliza();
            this.compartirCaraturaPoliza(this.parameters[0].pol, new Configuration().worksiteIdEncr, this.cocheSeguro.prospecto.correo, this.modeloCorreo);
            this.goMiCuenta();
          }
        }, error => {
          console.error("Ocurrió un problema durante el proceso", error);
          this.validando = 0;
          this.goMiCuenta();
        });
  }

  private cancelacion() {
    try {
      this.cancel.polizaId = this.parameters[0].pol;
      this.cancel.polizaIdComplemento = this.parameters[0].polCom;
      this.cancel.razon = "Cancelación por falta de pago:";
      this.cancel.motivo = "Cancelación por pago declinado";
      this.cancel.aplicarEndoso = true;
      this.cancel.opcion = 2;

      this.requestService.postRequest({ projectName: new Configuration().URLPOLIZAS, apiName: "MarketCancelacionAutoAPI", dataJSON: this.cancel })
        .subscribe(
          resultado => {
            if (resultado.error) {
              console.error("result.error2: ", resultado.error);
            } else {
              this.goMiCuenta();
            }
          }, error => {
            console.error("error en cancelacion de segunda", error);
            this.goMiCuenta();
          }
        );
    } catch (ex) {
      console.error(ex);
      this.goMiCuenta();
    }
  }

  actualizaNoPol() {
    try {
      const data = {
        'b': this.cocheSeguro[this.configuration.PROJECT_KEY],
        'v1': this.parameters[0].pol, //polizaId
        'v3': this.parameters[0].Pol, //número de póliza que retorna GNP
        'v5': 1,
        'modificar': 1
      }
      this.requestService.postRequest({ projectName: this.configuration.URLPOLIZAS, apiName: "Sio4PolizaDatosGeneralesAPI", dataJSON: data }).subscribe(result => {
        if (result.error) {
          console.error("Exception in request actualizaNoPol " + result.error);
        } else {
          this.activaPoliza();
        }
      }, error => {
        console.error("exception in request actualizaNoPol" + error);
      });
    } catch (e) {
      console.error("exception in actualizaNoPol", e)
    }
  }

  activaPoliza() {
    try {
      this.requestService.getRequest({ projectName: this.configuration.URLPOLIZAS, apiName: "Sio4ActivaPolizaAPI", params: [{ "pol": this.parameters[0].pol }] })
        .subscribe(result => {
          if (result.error) {
            console.error("Exception in request activaPoliza", result.error);
          }
        }, error => {
          console.error("exception in request activaPoliza", error);
        });
    } catch (e) {
      console.error("Exception in activaPoliza", e)
    }
  }

  goMiCuenta() {
    if (this.configuration.PLATFORM) {
      window.location.href = this.configuration.URLPLATFORM + 'mi-cuenta';
    } else {
      this.router.navigate(['mi-cuenta']);
    }
  }

  compartirMiPoliza() {
    /* Se agrego, pero como aun no se usa en el componente de datos-tarjeta, se dejo hasta alli */
    try {
      this.compartir.v1 = this.prospecto.correo;
      this.compartir.v2.push({ 'c1': this.parameters[0].pol, 'c3': 1 }, { 'c1': this.parameters[0].polCom, 'c3': 1 });
      this.compartir.pid = this.parameters[0].polid;
      this.requestService.postRequest({ projectName: new Configuration().URLMIPOLIZA, apiName: 'MiPolizaCompartePolizasAPI', dataJSON: this.compartir }).subscribe(
        result => {
          if (result.error) {
            console.error("error => ", result.error);
          } else {
          }
        }, error => {
          console.error("error => ", error);
        }
      )
    } catch (error) {
      console.error("error: ", error);
    }
  }

  compartirCaraturaPoliza(polizaIdEnc: string, worksiteIdEnc: string, email: string, modelo: number) {
    try {
      this.requestService.getRequest({ projectName: new Configuration().URLPOLIZAS, apiName: 'Sio4CorreoModeloCocheSeguroAPI', params: [{ v1: polizaIdEnc }, { v2: modelo }] }).subscribe(

        result => {
          if (result.error) {
            console.error('Ocurrió un problema durante el proceso', result.error);
          }
        }, error => {
          console.error('Ocurrió un problema durante el proceso', error);
        }
      )
    } catch (error) {
      console.error('Ocurrió un problema durante el proceso', error);
    }
  }

  creacionPolINBROKER() {
    try {
      let data = { polizaId: this.parameters[0].pol, worksiteId: new Configuration().worksiteIdEncr };
      this.requestService.postRequestAsync({ projectName: new Configuration().URLQuattroInbroker, apiName: "Sio4CreacionPolizaInbrokerAPI", dataJSON: data });

      //this.generaEstructuraBI(this.parameters[0].pol);
    } catch (error) {
      console.error("Error en creacionPolINBROKER " + error);
    }
  }

  generaEstructuraBI(poliza) {
    try {
      if(this.cocheSeguro.estructuraGrupoId > 0) {
        let data = {
          'estructura_id': this.cocheSeguro.estructuraGrupoId,
          'poliza_id': poliza
        };
        this.requestService.postRequest({projectName: new Configuration().BRIDGE_DATA_STRUCTURE_BI_AES, apiName: 'v1/bridge-data-structure-bi', dataJSON: data}).subscribe(
          result => {
            //console.log('result', result);
          },
          error => {
            console.error('error', error);
          }
        );
      }      
    } catch(error) {
      console.error("Error en generaEstructuraBI " + error);
    }
  }

  sendCRM() {
    try {
      const accionSio = {
        A: 0,
        R: '',
        C: this.parameters[0].clid ? this.parameters[0].clid : 0,
        E: 0,
        M: 0,
        P: 0,
        R1: 0,
        E1: 0,
        A1: 0,
        C1: []
      }

      const data = {
        accionSio: JSON.stringify(accionSio),
        O: [],
        S: 0,
        asunto: "Coche Seguro Cobro en Línea (GNP)",
        descripcion: this.parameters[0].Pol,
        etiquetas: [],
        crmTipo: 0,
        apps_ids: [
          {
            "id": 1
          },
          {
            "id": 3
          }
        ],
        b: this.cocheSeguro[this.configuration.PROJECT_KEY]
      }
      this.requestService.postRequest({ projectName: this.configuration.URLPOLIZAS, apiName: "crm-tarea-api-v2", dataJSON: data }).subscribe(result => {
        if (result.error) {

        } else {

        }
      })
    } catch (e) {
      console.error("Exception in sendCRM " + e);

    }
  }

  pagoExitoso(numero: number) {
    gtag({
      'event': 'GNP_pago',
      'status': numero,      //valor NUMERICO de la propiedad Res
      'polizaId': this.parameters[0].polid    //variable polizaId 
    });
  }
}
